// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1ClDE","title":"FrontImage_title__2RGWV"};